import * as React from 'react';

import classnames from 'classnames';

import type {User} from 'nutshell-core/types';

import {ConstantContactPopover} from '../../core/constant-contact/constant-contact-popover/constant-contact-popover';

import styles from './actions.module.css';

export type Props = {
    isDisabled: boolean;
    onExportToConstantContact: () => void;
    selectedCount: number;
    displayName: string;
    displayNameSingular: string;
    user: User;
    handleConstantContactSubmit: (data: {
        listId: string | null | undefined;
        listName: string | null | undefined;
    }) => Promise<any>;
};

export function ConstantContactButton(props: Props) {
    const [isConstantContactPopoverOpen, setIsConstantContactPopoverOpen] = React.useState(false);

    const ccButtonRef = React.useRef(null);

    return (
        <>
            <button
                ref={ccButtonRef}
                type='button'
                disabled={props.isDisabled}
                onClick={() => setIsConstantContactPopoverOpen(true)}
                className={classnames(
                    'popover-opener-constant-contact',
                    styles['mailchimp-button']
                )}
            >
                Send to Constant Contact
            </button>
            {isConstantContactPopoverOpen && (
                <ConstantContactPopover
                    anchor={ccButtonRef.current}
                    onCancel={() => setIsConstantContactPopoverOpen(false)}
                    onSubmit={props.handleConstantContactSubmit}
                    submitButtonText={`Send ${props.selectedCount} ${
                        props.selectedCount > 1 ? props.displayName : props.displayNameSingular
                    }`}
                    canAccessIntegrations={Boolean(
                        props.user && props.user.permissions.canAccessSetup
                    )}
                    onSuccess={() => {
                        setIsConstantContactPopoverOpen(false);
                        Popmini.open(
                            'Successfully sent to Constant Contact. It may take a few moments for them to appear there.',
                            {
                                attachTo: $('.popover-opener-constant-contact'),
                                classes: 'type-message',
                                orientation: 'north',
                            }
                        );
                        props.onExportToConstantContact();
                    }}
                />
            )}
        </>
    );
}
